import { getSession } from 'next-auth/react';
import backendFetch, { TokenExpiredError } from '../../utils/backendFetch';

class BaseApi {
  constructor(private idToken?: string) {}

  protected buildFormData = <T extends object>(content: T) => {
    const formData = new FormData();
    Object.entries(content).forEach(([key, value]) =>
      formData.append(
        key,
        typeof value === 'object' && !(value instanceof Blob)
          ? JSON.stringify(value)
          : value
      )
    );
    return formData;
  };

  execute(input: RequestInfo | URL, init?: any, isFormData?: boolean) {
    return backendFetch(input, init, this.idToken, isFormData);
  }
}

export default BaseApi;
